module.exports = __webpack_public_path__ + "img/714.a4721382.png";